
const pages = require.context('../', true, /_page\.coffee$/)
pages.keys().forEach(pages)
